import { AxiosError } from 'axios';
import { PUT_JOB_STATUS_REPORTS_RESET_RETRY_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutJobStatusReportResetRetry = ({ onError, onSuccess }: Input) => {
  const putJobStatusReportsResetRetry = async (uuids: string[]) => {
    const res = await axiosClient.put(PUT_JOB_STATUS_REPORTS_RESET_RETRY_URL, uuids);

    return res.data;
  };

  return useCustomMutation(putJobStatusReportsResetRetry, {
    onSuccess,
    onError,
  });
};
